<app-card>
  <form [formGroup]="searchForm">
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'common.date.start' | translate }}</label>
          <input type="date" appInput autofocus formControlName="startDate">
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'common.date.end' | translate }}</label>
          <input type="date" appInput formControlName="endDate">
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.search.meteringpointtype' | translate }}</label>
          <select appSelect [collection]="meteringPointType" formControlName="typeOfMeteringPoint">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.search.settlementmethod' | translate }}</label>
          <select appSelect [collection]="settlementMethod" formControlName="settlementMethod">
          </select>
        </app-input-group>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.search.businessreasoncode' | translate }}</label>
          <select appSelect [collection]="businessReasonCode" formControlName="businessReasonCode">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.search.processvariant' | translate }}</label>
          <select appSelect [collection]="processVariant" formControlName="processVariant">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.search.datahubstatus' | translate }}</label>
          <select appSelect [collection]="dataHubStatus" formControlName="dataHubStatus">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4"></div>
    </div>
    <div>
      <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
    </div>
  </form>
</app-card>

<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
